import { DateTime } from 'luxon'

export function getOccurrenceEventType(occurrence) {
  const ev = occurrence?.event
  if (!ev?.__typename) return null
  return ev.__typename
}

export function isGoogleBusyTime(occurrence) {
  return getOccurrenceEventType(occurrence) === 'GoogleCalendarBusyTime'
}

export function isCoachBlockTime(occurrence) {
  return getOccurrenceEventType(occurrence) === 'CoachAvailabilityBlockTime'
}

export function formatOccurrenceTimeRange(occurrence) {
  if (!occurrence?.startDateTime || !occurrence?.endDateTime) return ''
  const start = DateTime.fromISO(occurrence.startDateTime)
  const end = DateTime.fromISO(occurrence.endDateTime)
  if (!start.isValid || !end.isValid) return ''
  return `${start.toFormat('h:mm a')} – ${end.toFormat('h:mm a')}`
}

export function formatOccurrenceDate(occurrence) {
  if (!occurrence?.startDateTime) return ''
  const start = DateTime.fromISO(occurrence.startDateTime)
  return start.isValid ? start.toFormat('EEEE, MMMM d, yyyy') : ''
}

export function occurrenceDisplayTitle(occurrence) {
  if (occurrence?.title) return occurrence.title
  const ev = occurrence?.event
  if (!ev) return 'Event'
  if (ev.__typename === 'Session') {
    return ev.lessonType?.title || 'Session'
  }
  if (ev.__typename === 'GroupEvent') return 'Group Event'
  if (ev.__typename === 'CoachAvailabilityBlockTime') {
    return ev.blockNote || 'Blocked time'
  }
  if (ev.__typename === 'GoogleCalendarBusyTime') {
    return 'External calendar busy'
  }
  return 'Event'
}

export function occurrenceParticipantLine(occurrence) {
  if (occurrence?.participantName) return occurrence.participantName
  const ev = occurrence?.event
  if (!ev || (ev.__typename !== 'Session' && ev.__typename !== 'GroupEvent')) {
    return null
  }
  const active = (ev.enrollments || []).filter(
    e => e && !e.isCanceled && e.student,
  )
  if (active.length === 0) return null
  const first = active[0].student
  const name = [first.firstName, first.lastName].filter(Boolean).join(' ')
  if (!name) return null
  return active.length > 1 ? `${name} +${active.length - 1} more` : name
}

/** Minimal GroupEvent shape for EventDetailsDialog when full fetch succeeds. */
export function groupEventFromOccurrence(occurrence, fullEvent) {
  if (fullEvent) return fullEvent
  const ev = occurrence?.event
  if (!ev || ev.__typename !== 'GroupEvent') return null
  return {
    __typename: 'GroupEvent',
    id: ev.id,
    slug: ev.slug,
    isCanceled: ev.isCanceled,
    startDateTime: occurrence.startDateTime,
    endDateTime: occurrence.endDateTime,
    enrollments: ev.enrollments || [],
    sessions: [
      {
        startDateTime: occurrence.startDateTime,
        endDateTime: occurrence.endDateTime,
        enrollments: ev.enrollments || [],
      },
    ],
  }
}

/** Minimal Session booking shape for read-only display. */
export function sessionBookingFromOccurrence(occurrence, coach) {
  const ev = occurrence?.event
  if (!ev || ev.__typename !== 'Session') return null
  return {
    __typename: 'Session',
    id: ev.id,
    isCanceled: ev.isCanceled,
    startDateTime: occurrence.startDateTime,
    endDateTime: occurrence.endDateTime,
    title: ev.lessonType?.title || occurrence.title || 'Session',
    enrollments: ev.enrollments || [],
    lessonType: ev.lessonType || { title: occurrence.title || 'Session' },
    coach: coach ? { id: coach.id, name: coach.name } : null,
  }
}

/** Block time shape for read-only display. */
export function blockTimeFromOccurrence(occurrence) {
  const ev = occurrence?.event
  if (!ev || ev.__typename !== 'CoachAvailabilityBlockTime') return null
  return {
    id: ev.id,
    blockNote: ev.blockNote,
    startTime: occurrence.startDateTime,
    endTime: occurrence.endDateTime,
  }
}
